
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { ChaseAdvancePaymentProcessInput } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentProcessInput';
import { ChaseAdvancePaymentTransactionStatus } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentTransactionStatus';
import { GetEnvVarService } from "../../../../service/get-env-var.service";

@Injectable()
export class AdvancePaymentStatusServiceService {

  private baseUrl: string;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }


  getTransactionStatusFromUID(uId: string): Observable<ChaseAdvancePaymentTransactionStatus> {
    // debugger;
    return this.http.get(this.baseUrl + `/api/advancePayments/getTransactionStatusFromUID/` + uId).pipe(
      map(response => response as ChaseAdvancePaymentTransactionStatus));
  }

}
